var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBrandRailcard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#E10A0A",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 12.167a3 3 0 0 1 3 3v42.666a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V15.167a3 3 0 0 1 3-3h67zm-2.563 4.562H5.563a1 1 0 0 0-1 1v37.542a1 1 0 0 0 1 1h61.874a1 1 0 0 0 1-1V17.729a1 1 0 0 0-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.292 42.583a7.604 7.604 0 0 1 7.452 9.126l-.001-.001H13.84a7.613 7.613 0 0 1-.143-1.132l-.01-.389c0-4.2 3.405-7.604 7.605-7.604zm11.166-21.291a1 1 0 0 1 1 1v28.416c0 .067-.006.131-.018.194.011-.237.018-.475.018-.715 0-5.434-3.563-10.037-8.48-11.597a7.604 7.604 0 1 0-7.371-.001c-4.919 1.561-8.482 6.164-8.482 11.599 0 .243.007.484.02.724l-.001-.01a1.005 1.005 0 0 1-.019-.194V22.292a1 1 0 0 1 1-1h22.333zm-11.166 7.604a3.042 3.042 0 1 1 0 6.083 3.042 3.042 0 0 1 0-6.083z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.021,
    y: 24.333,
    width: 25.854,
    height: 4.563,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.021,
    y: 33.458,
    width: 25.854,
    height: 4.563,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.021,
    y: 42.583,
    width: 22.161,
    height: 4.563,
    rx: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrandRailcard);
export default __webpack_public_path__ + "static/media/icon-brand-railcard.1b2d780791d8b0b48be24618c84b56d4.svg";
export { ForwardRef as ReactComponent };